export type AppTheme = 'light' | 'dark';

const STORAGE_KEY = 'krysalis-theme';

export function resolveTheme(value?: string | null): AppTheme {
  return value === 'dark' ? 'dark' : 'light';
}

export function readStoredTheme(): AppTheme | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'light' || raw === 'dark') {
      return raw;
    }
  } catch {
    /* ignore storage errors */
  }
  return null;
}

export function writeStoredTheme(theme: AppTheme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* ignore storage errors */
  }
}

/** Apply canonical theme attributes on <html> for CSS token overrides. */
export function applyThemeToDocument(theme: AppTheme): void {
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  root.classList.toggle('dark', theme === 'dark');
  root.style.colorScheme = theme;
}

export function resolveActiveTheme(profileTheme?: string | null): AppTheme {
  return resolveTheme(readStoredTheme() ?? profileTheme);
}
